import { UserEntity } from 'sonata-static-storage/lib/entities';
import { fetchSessionCustomization, getCurrentUser } from 'sonata-static-storage/lib/helpers/user.helpers';

import type { StateCreator } from 'zustand';

type UserStore = {
  reloadUser: (token: Record<string, any>) => Promise<void>;
  setUser: (token: Record<string, any>) => Promise<void>;
  user: UserEntity;
};

export const userStore: StateCreator<UserStore, [['zustand/devtools', never]], []> = set => {
  const writeUser = async (token: Record<string, any>, action: string) => {
    const user = await getCurrentUser(token);
    if (!user) {
      return;
    }
    await fetchSessionCustomization(user, token);
    set({ user }, false, action);
  };

  return {
    reloadUser: token => writeUser(token, 'user/reloadUser'),
    setUser: token => writeUser(token, 'user/setUser'),
    user: {} as UserEntity
  };
};
